<template>
  <GenericLayout :title="$t('LOGIN.TITLE')" class="fill-height">
    <v-row no-gutters style="height: 100%">
      <v-col
          md="8"
          cols="12"
          class="register-hero"
          pb-3
      >
        <v-layout justify-center align-center>
          <v-flex shrink>
            <v-img contain
                   min-width="100"
                   src="@/assets/logo.svg"
                   width="300"/>
          </v-flex>
        </v-layout>
        <v-layout class="claims-text-container" justify-center align-center>
          <v-flex pb-6 shrink>
            <h2>{{ $t('REGISTER.REGISTER_1') }}</h2>
            <h3>{{ $t('REGISTER.REGISTER_2') }}</h3>
            <h4>{{ $t('REGISTER.REGISTER_3') }}</h4>
            <h4>{{ $t('REGISTER.REGISTER_4') }}</h4>
            <h3>{{ $t('REGISTER.REGISTER_5') }}</h3>
          </v-flex>
        </v-layout>
      </v-col>

      <v-col
        md="4"
        cols="12"
        class="px-4 py-10"
      >
        <form>
          <p>
            <v-text-field
              v-model="user"
              type="text"
              name="username"
              :label="$t('LOGIN.USERNAME')"
              class="input-group--focused"
            ></v-text-field>
          </p>
          <p>
            <v-text-field
              v-model="pass"
              :append-icon="show ? 'visibility_off' : 'visibility'"
              :rules="[rules.required, rules.min]"
              :type="show ? 'text' : 'password'"
              name="password"
              :label="$t('LOGIN.PASSWORD')"
              hint="At least 8 characters"
              class="input-group--focused"
              @click:append="show = !show"
            ></v-text-field>
          </p>

          <BaseLoader v-if="loading" />
          <BaseButton v-else @click="login()">
            {{ $t('LOGIN.SUBMIT') }}
          </BaseButton>
          <v-btn
            rounded
            block
            large
            text
            class="my-4"
            @click="$router.push({ name: 'resetPass' })"
          >
            {{ $t('LOGIN.RESET_PASSWORD') }}
          </v-btn>

          <p class="text-center mt-8">
            <router-link to="register">
              {{ $t('REGISTER.TITLE') }}
            </router-link>
          </p>
          <p class="text-center mt-4 mb-8">
            <router-link to="home">
              {{ $t('PLAY_ANONYMOUSLY') }}
            </router-link>
          </p>

        </form>
      </v-col>
    </v-row>
  </GenericLayout>
</template>

<style scoped>
.register-hero {
  background-color: #ffeaef;
  background-image: url('../assets/img/banner-left.png');
  background-size: 50%;
  background-position: 0% 100%;
}

@media screen and (max-height: 960px) {
  .register-hero {
    background-size: 18%;
  }
}

@media screen and (max-width: 960px) {
  .register-hero {
    background-image: url('../assets/img/monigotes/1_opacity.png'),
                      url('../assets/img/monigotes/2_opacity.png'),
                      url('../assets/img/monigotes/3_opacity.png');
    background-size: 20%, 21%, 22%;
    background-position: 44% 85%, 20% 68%, 70% 75%;
  }
}

.claims-text-container{
  max-width: 80%;
  width: 80%;
  margin: 0 auto;
}

.claims-text-container h3, .claims-text-container h4{
  margin-top: 1rem;
}
</style>

<script>
import GenericLayout from '@/layouts/GenericLayout.vue';

export default {
  name: 'Login',
  components: {
    GenericLayout,
  },
  data: () => ({
    user: '',
    pass: '',
    show: false,
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
    },
  }),
  computed: {
    loading() {
      return this.$store.state.session.isLoading;
    },
  },
  methods: {
    login() {
      this.$store.dispatch('session/login', {
        name: this.user,
        pass: this.pass,
      })
        .then(() => {
          this.$track('login', 'auth');
          this.goHomeIfLogged();
        });
    },
    goHomeIfLogged() {
      const { session } = this.$store.state;
      if (session.isLogged && !session.isAnonymous) {
        this.$router.replace({ name: 'home' });
      }
    },
  },
  created() {
    this.goHomeIfLogged();
  },
};
</script>
